import { useState, useEffect } from 'react'
import { api } from '../../Controllers/api'

export function useSites() {
  const [siteList, setSiteList] = useState()
  const [loading, setLoading] = useState(true)

  const refreshSites = () => {
    api.get(`sites`).then(({ data }) => {
      // console.log(data)
      setSiteList(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    refreshSites()
  }, []) //eslint-disable-line

  return { loading, siteList, refreshSites }
}

export function useCreateSiteModal() {
  const [createNewSiteModal, setVisible] = useState(false)

  const handleCreateNewSiteModal = () => {
    setVisible(!createNewSiteModal)
  }

  return { createNewSiteModal, handleCreateNewSiteModal }
}

export function useEditSiteModal() {
  const [editSiteModal, setVisible] = useState(false)

  const handleEditSiteModal = () => {
    setVisible(!editSiteModal)
  }

  return { editSiteModal, handleEditSiteModal }
}

export function useEditGeofencedSiteModal() {
  const [editGeofencedSiteModal, setVisible] = useState(false)

  const handleEditGeofencedSiteModal = () => {
    setVisible(!editGeofencedSiteModal)
  }

  return { editGeofencedSiteModal, handleEditGeofencedSiteModal }
}

export function useSiteActionModal() {
  const [siteActionvisible, setVisible] = useState(false)

  const handleShowSiteAction = () => {
    setVisible(true)
    setTimeout(() => {
      setVisible(false)
    }, 2500)
  }

  return { siteActionvisible, handleShowSiteAction }
}
